<template>
  <div>
    <b-table
      v-show="rows > 0"
      :items="items"
      :fields="gameListFields"
      responsive
      class="compact-table-sm"
      :per-page="perPage"
      :current-page="currentPage"
      primary-key="id"
      ref="table"
    >
      <template #cell(as)="data">
        <span v-if="data.item.won">
          <font-awesome-icon title="Winner" :icon="['fas', 'trophy']" />
        </span>
        <span
          v-if="data.item.went_first"
          class="fa-layers fa-fw"
          title="Player 1"
        >
          <font-awesome-icon :icon="['fas', 'diamond']" />
          <font-awesome-layers-text
            transform="shrink-5"
            class="fa-inverse"
            value="1"
          />
        </span>
        <router-link
          v-if="data.value.type === 'fan'"
          :to="{ name: 'EditDeck', params: { id: data.value.slug } }"
        >
          {{ data.value.name }}
        </router-link>
        <router-link
          v-else
          :to="{ name: 'UmDbDeck', params: { slug: data.value.slug } }"
        >
          {{ data.value.name }}
        </router-link>
      </template>

      <template #cell(vs)="data">
        <span v-if="!data.item.won">
          <font-awesome-icon title="Winner" :icon="['fas', 'trophy']" />
        </span>
        <span
          v-if="data.item.went_first === false"
          class="fa-layers fa-fw"
          title="Player 1"
        >
          <font-awesome-icon :icon="['fas', 'diamond']" />
          <font-awesome-layers-text
            transform="shrink-5"
            class="fa-inverse"
            value="1"
          />
        </span>
        <router-link
          v-if="data.value.type === 'fan'"
          :to="{ name: 'EditDeck', params: { id: data.value.slug } }"
        >
          {{ data.value.name }}
        </router-link>
        <router-link
          v-else
          :to="{ name: 'UmDbDeck', params: { slug: data.value.slug } }"
        >
          {{ data.value.name }}
        </router-link>
      </template>

      <template #cell(rating)="rating">
        <b-form-rating
          v-if="rating.value"
          v-model="rating.value"
          readonly
        ></b-form-rating>
      </template>

      <template #cell(played_on)="played_on">
        {{ formatDate(played_on.value, "MMM D, YYYY") }}
      </template>

      <template #cell(details)="row">
        <div class="text-nowrap">
          <!-- need to wrap the fa icons in spans to make them properly reactive -->
          <span v-show="showPrivateIcons && !row.item.is_public">
            <font-awesome-icon
              title="Private"
              class="mx-1"
              :icon="['fas', 'user-secret']"
            />
          </span>

          <span v-show="showPrivateIcons && row.item.is_public">
            <font-awesome-icon
              title="Public"
              class="mx-1"
              :icon="['far', 'globe']"
            />
          </span>

          <span v-show="row.item.notes">
            <font-awesome-icon
              title="Has notes"
              class="mx-1"
              :icon="['far', 'sticky-note']"
            />
          </span>
          <b-button
            v-if="
              row.item.rounds !== null ||
              row.item.winner_hp !== null ||
              row.item.loser_hp !== null ||
              row.item.notes
            "
            @click="row.toggleDetails"
            variant="link"
            href="#"
            class="px-1"
          >
            <span v-show="row.detailsShowing">
              <font-awesome-icon
                title="Hide details"
                :icon="['fas', 'minus-circle']"
              />
            </span>
            <span v-show="!row.detailsShowing">
              <font-awesome-icon
                title="Show details"
                :icon="['fas', 'plus-circle']"
              />
            </span>
          </b-button>
          <b-button
            v-if="row.item.recorded_by === $store.getters.currentUser"
            variant="link"
            href="#"
            class="px-1"
            @click="editGame(row.item)"
          >
            <font-awesome-icon title="Edit" :icon="['fas', 'edit']" />
          </b-button>
        </div>
      </template>

      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col> <b>Rounds:</b> {{ row.item.rounds }} </b-col>
            <b-col>
              <b>Winning fighter's final HP:</b> {{ row.item.winner_hp }}
            </b-col>
            <b-col>
              <b>Defeated fighter's final HP:</b> {{ row.item.loser_hp }}
            </b-col>
          </b-row>

          <b-row class="mb-2" v-if="row.item.notes">
            <b-col><b>Notes:</b> {{ row.item.notes }}</b-col>
          </b-row>
        </b-card>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      v-if="rows > perPage"
      :total-rows="rows"
      :per-page="perPage"
      first-number
      last-number
    ></b-pagination>
    <TrackGameModal ref="editGame" :game="editingGame" @refresh="refresh" />
  </div>
</template>

<script>
import dateFormat from "@/mixins/dateFormat";

import TrackGameModal from "@/components/TrackGameModal.vue";

export default {
  name: "GameList",
  mixins: [dateFormat],
  components: { TrackGameModal },
  props: {
    items: {
      required: true,
    },
    rows: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    showPrivateIcons: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      gameListFields: [
        { key: "as", sortable: true },
        { key: "vs", sortable: true },
        { key: "opponent_name", label: "Opponent", sortable: true },
        { key: "recorded_by", label: "Recorded by", sortable: true },
        { key: "board_name", sortable: true },
        { key: "rating", sortable: true },
        { key: "played_on", sortable: true },
        "details",
      ],
      editingGame: null,
    };
  },
  methods: {
    refresh() {
      this.$emit("refresh");
      this.$refs.table.refresh();
    },
    editGame(game) {
      this.editingGame = game;
      this.$refs.editGame.show();
    },
  },
};
</script>

<style>
@media (prefers-color-scheme: dark) {
  .fa-inverse {
    color: #000;
  }
}
</style>
